var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0001 6.82051C7.46932 6.82051 8.66036 5.62948 8.66036 4.16026C8.66036 2.69104 7.46932 1.5 6.0001 1.5C4.53088 1.5 3.33984 2.69104 3.33984 4.16026C3.33984 5.62948 4.53088 6.82051 6.0001 6.82051Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2565 11.0767C10.2565 9.94785 9.80803 8.86522 9.0098 8.06699C8.21157 7.26875 7.12893 6.82031 6.00006 6.82031C4.87119 6.82031 3.78856 7.26875 2.99033 8.06699C2.19209 8.86522 1.74365 9.94785 1.74365 11.0767",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRegister);
export default __webpack_public_path__ + "static/media/btn_register.542164fd7a44a3880f8fa7eed39d9987.svg";
export { ForwardRef as ReactComponent };